/** Blindness — draw blind. The canvas goes dark until you lift the pen. */
import type { AffectModule } from '../../core/module-api';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3l18 18"/><path d="M10.6 5.1A9 9 0 0 1 21 12a9 9 0 0 1-1.6 2.5"/><path d="M6.6 6.6A9 9 0 0 0 3 12a9 9 0 0 0 12.5 6.5"/></svg>';

export function createBlindness(): AffectModule {
  return {
    manifest: {
      id: 'blindness',
      kind: 'affect',
      name: 'Blind',
      apiVersion: 1,
      description: 'Draw blind — the canvas hides until you lift the pen, then reveals.',
      icon: ICON,
    },

    affect(shapes, ctx) {
      ctx.requestBlind();
      return shapes.slice();
    },
  };
}
